import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { get } from 'lodash'
import BillingAccountForm from './BillingAccountForm'
import { createBillingAccount, updateBillingAccount } from '../Billing.actions'

const formName = 'billingAccountForm'

const stateToProps = (
  { form, billing: { billingAccounts, createLoading, updateLoading } },
  { billingAccount }
) => {
  const formData = get(form, `${formName}.values`, {})

  const actualBillingAccount =
    billingAccount || billingAccounts.find(account => account.ban === formData.ban) || {}

  return {
    form: formName,
    formData,
    initialValues: {
      ban: actualBillingAccount.ban,
      customer: actualBillingAccount.customer,
      abn: actualBillingAccount.abn,
      invoiceDelivery: actualBillingAccount.invoiceDelivery,
      address: actualBillingAccount.address,
      postalCode: actualBillingAccount.postalCode,
      suburb: actualBillingAccount.suburb,
      state: actualBillingAccount.state,
      directDebitMethod: actualBillingAccount.directDebitMethod,
      country: 'Australia',
    },
    billingAccount: actualBillingAccount,
    isEdit: !!billingAccount,
    loading: createLoading || updateLoading,
  }
}

const dispatchToProps = {
  createBillingAccount,
  updateBillingAccount,
}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    form: formName,
    enableReinitialize: true,
  })(BillingAccountForm)
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAccountForm/BillingAccountForm.container.js